import React from 'react';
import useActiveMeetingScreenShare from 'flow/hooks/useActiveMeetingScreenShare';
import MeetingButton from 'flow/components/meeting/MeetingButton';

interface Props {
    setElectronScreenShareMenuIsOpen: React.Dispatch<
        React.SetStateAction<boolean>
    >;
}

export const ButtonToggleScreenShare = ({
    setElectronScreenShareMenuIsOpen,
}: Props) => {
    const {
        screenShareIsSupported,
        screenSharingIsActive,
        togglingScreenSharingIsBlocked,
        toggleScreenSharing,
        screenShareHoverText,
    } = useActiveMeetingScreenShare(setElectronScreenShareMenuIsOpen);

    // Hidden where screen capture can't work — i.e. mobile browsers/webviews
    // with no getDisplayMedia — rather than shown as a button that always fails.
    if (!screenShareIsSupported) return null;

    return (
        <div className="flex flex-col items-center justify-center text-xs select-none">
            <MeetingButton
                iconType={'screen_share_outlined'}
                active={screenSharingIsActive}
                callback={toggleScreenSharing}
                hoverText={screenShareHoverText}
                disabled={togglingScreenSharingIsBlocked}
            />
        </div>
    );
};

export default ButtonToggleScreenShare;
